import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 用户站内消息页面常量
 */
export class UserMessagePageConstants extends UltMeta {
    STORE_DETAIL_PAGE = new Meta(1, "项目详情");
    FIND_BOAT_DETAIL_PAGE = new Meta(2, "采购订单详情页");
    DELIVER_GOODS_DETAIL_PAGE = new Meta(3, "提货详情");
    SIGN_RECEIPT_DETAIL_PAGE = new Meta(4, "签收详情");
    RECONCILIATION_DETAIL_PAGE = new Meta(5, "结算详情");
    BILL_PAYMENT_DETAIL_PAGE = new Meta(6, "开票详情");
    PAYMENT_DETAIL_PAGE = new Meta(7, "付款详情");
    CONTRACT_DETAIL_PAGE = new Meta(8, "合同详情");
    INSTITUTION_APPLY_DETAIL_PAGE = new Meta(9, "组织机构认证详情");
    CUSTOMER_ENTERPRISE_APPLY_DETAIL_PAGE = new Meta(10, "受邀记录详情");
    QUOTA_CHANGE_APPLY_DETAIL_PAGE = new Meta(11, "额度变更详情");
    REFUND_DETAIL_PAGE = new Meta(12, "退款详情");
    SERVICE_FEE_DETAIL_PAGE = new Meta(13, "服务费详情");
    FINANCING_DETAIL_PAGE = new Meta(14, "融资详情页");
    LOAN_RECEIPT_DETAIL_PAGE = new Meta(15, "借据管理");
    REPAYMENT_DETAIL_PAGE = new Meta(16, "还款详情页");
}

export const USER_MESSAGE_PAGE_CONSTANTS = new UserMessagePageConstants();
